import { useState } from "react";
import useModalActions from "../../../../hooks/useModalActions";
import emitter, { MODAL_TYPES } from "../../../../utils/emitter";

export default function useViewController() {
  const { openModal, closeModal } = useModalActions();
  const [descriptionIsOpen, setDescriptionIsOpen] = useState(false);

  const openCard = (card, cards) => {
    openModal(MODAL_TYPES.SWIPER, { cards, card });
  };

  const closeCard = (card, cards) => {
    emitter.emit(MODAL_TYPES.SWIPER, {
      isOpen: false,
      payload: { cards, card },
    });
  };

  return {
    closeCard,
    openCard,
    showDescription: (isShowMore) => setDescriptionIsOpen(isShowMore),
    descriptionIsOpen,
  };
}
